import { List, fromJS, getIn } from 'immutable';

import UserReportModel from 'models/UserReportModel';
import ActivityReportModel from 'models/ActivityReportModel';
import FundingSearchReportModel from 'models/FundingSearchReportModel';

import { teamUserReports } from './types';
import reportEntitiesReducerObject from './reportEntities/reducer';
import { combineReducerArray } from '../utils/helpers';

export * from './actions';

const initialState = fromJS({
  byTeam: {
    // [team.id]: {
    //     users: [],
    //     invites: [],
    //     activities: [],
    //     fundingSearches: [],
    //     network: { loading: false, error: false },
    // },
  },
  teamUsersReport: {
    ids: [],
    network: { loading: false, error: false },
  },
  reportEntities: {
    data: [],
    network: { loading: false, error: false },
  },
});

const userReportReducer = {
  [teamUserReports.request]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['teamUsersReport', 'network', 'loading'], true)
        .updateIn(['byTeam'], (byTeam) =>
          action.teamIds.reduce(
            (acc, teamId) => acc.setIn([teamId, 'network', 'loading'], true),
            byTeam,
          ),
        ),
    ),
  [teamUserReports.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .mergeIn(['teamUsersReport', 'ids'], fromJS(action.teamIds))
        .setIn(['teamUsersReport', 'network', 'loading'], false)
        .setIn(['teamUsersReport', 'network', 'error'], false)
        .updateIn(['byTeam'], (byTeam) =>
          action.teamIds.reduce(
            (acc, teamId) =>
              acc
                .setIn([teamId, 'network', 'loading'], false)
                .setIn([teamId, 'network', 'error'], false)
                .setIn(
                  [teamId, 'invites'],
                  fromJS(getIn(action, ['response', teamId, 'invites'], [])),
                )
                .setIn(
                  [teamId, 'fundingSearches'],
                  List(getIn(action, ['response', teamId, 'fundingSearches'], [])).map(
                    (searchReport) => FundingSearchReportModel.deserialize(searchReport),
                  ),
                )
                .setIn(
                  [teamId, 'activities'],
                  List(getIn(action, ['response', teamId, 'activities'], [])).map(
                    (activityReport) => ActivityReportModel.deserialize(activityReport),
                  ),
                )
                .setIn(
                  [teamId, 'users'],
                  List(getIn(action, ['response', teamId, 'users'], [])).map((userReport) =>
                    UserReportModel.deserialize(userReport),
                  ),
                ),
            byTeam,
          ),
        ),
    ),
  [teamUserReports.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['teamUsersReport', 'network', 'loading'], false)
        .setIn(['teamUsersReport', 'network', 'error'], action.error)
        .updateIn(['byTeam'], (byTeam) =>
          action.teamIds.reducer(
            (acc, teamId) =>
              acc
                .setIn([teamId, 'network', 'loading'], false)
                .setIn([teamId, 'network', 'error'], action.error),
            byTeam,
          ),
        ),
    ),
};

export default combineReducerArray(initialState, [userReportReducer, reportEntitiesReducerObject]);
